import { ReferenceInput, SelectInput } from "ra-ui-materialui";

import React from "react";
import { useTranslate } from "react-admin";

const optionText = (option) => `${option.code} - ${option.description}`;
const ProductionChainInput = ({ tab = 1, ...props }) => {
  const translate = useTranslate();
  return (
    <ReferenceInput
      {...props}
      reference="production-chains"
      sort={{ field: "id", order: "ASC" }}
    >
      <SelectInput
        optionText={optionText}
        helperText={translate(
          "resources.research-projects.fields.production_chain_id.help"
        )}
      />
    </ReferenceInput>
  );
};
export default ProductionChainInput;
